import posthog from 'posthog-js'
import { v7 as uuidv7 } from 'uuid'

declare let core_object: any;

const phc_type: string = core_object.posthog.api_type;
const phc_key_test = process.env.POSTHOG_API_KEY_TEST;
const phc_key_live = process.env.POSTHOG_API_KEY_LIVE;
const phc_host = process.env.POSTHOG_HOST;
const PH_API_KEY = phc_type === 'test' ? phc_key_test : phc_key_live;
const PH_HOST = phc_host;

function toBool(v: unknown): boolean {
  if (typeof v === 'boolean') return v;
  if (typeof v === 'number') return v === 1;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    if (['true', '1', 'yes', 'on', 'si', 'sì'].includes(s)) return true;
    if (['false', '0', 'no', 'off', '', 'null', 'undefined'].includes(s)) return false;
  }
  return false; // default sicuro
}

export const POSTHOG_ENABLED = (() => {
  const active = toBool(core_object?.posthog?.active);
  const alg    = toBool(core_object?.alg);
  return active && !alg;
})();


// Espone una Promise che si risolve quando PostHog è pronto
// let _resolveReady: (ph: typeof posthog) => void
// export const posthogReady: Promise<typeof posthog> = new Promise((res) => (_resolveReady = res));

let resolveReady: (ph: typeof posthog) => void = () => {};   // ← default
export const posthogReady: Promise<typeof posthog> = new Promise((res) => { resolveReady = res; });

const BOOT_FLAG = '__PH_BOOTSTRAPPED__';

// console.log('[PH] flags', {
//     raw_active: core_object?.posthog?.active,
//     raw_alg: core_object?.alg,
//     active: toBool(core_object?.posthog?.active),
//     alg: toBool(core_object?.alg),
//     POSTHOG_ENABLED,
// });

if(typeof window !== 'undefined' && !(window as any)[BOOT_FLAG]){
    
    if (POSTHOG_ENABLED && PH_API_KEY) {

        const SID_KEY = 'pph_ephemeral_sid'
        let sid = sessionStorage.getItem(SID_KEY) as string;
        if (!sid) { sid = uuidv7(); sessionStorage.setItem(SID_KEY, sid); }

        posthog.init(PH_API_KEY as string, {
            api_host: PH_HOST,
            persistence: 'memory',
            disable_cookie: true,
            disable_session_recording: true,
            person_profiles: 'identified_only',
            autocapture: false,
            capture_pageview: false,
            bootstrap: { distinctID: sid, isIdentifiedID: false },
            loaded: (ph) => {

                if (ph.get_distinct_id() !== sid) {

                    const p = (ph as any).persistence
                    p?.set_property?.('distinct_id', sid)
                    p?.set_property?.('$device_id', sid)
            
                }

                posthog.set_config({ autocapture: true });

                ph.capture('$pageview', {}, {
                    send_instantly: true,
                    // @ts-ignore
                    disable_persistence: true
                });

                resolveReady(posthog);

                // console.log('[PH Init]', {
                //     persistence: (ph as any).config?.persistence,
                //     distinct_id: ph.get_distinct_id(),
                // });

            },
        });

        (window as any)[BOOT_FLAG] = true;

    } else {
        
        // DISABILITATO: risolvi comunque la promise per non bloccare chi attende
        (window as any)[BOOT_FLAG] = 'disabled';
        resolveReady(posthog);
        // (facoltativo) console.info('[PostHog] disabled via config');
    
    }

}

export { posthog }